export const docOptions = [
  { value: 'DOCUMENTS_EXTERNAL_COMMERCIAL_PROPOSAL', label: '1.1a) Commercial Proposal' },
  { value: 'DOCUMENTS_EXTERNAL_COMMERCIAL_DEVIATION', label: '1.1b) Commercial deviation' },
  { value: 'DOCUMENTS_EXTERNAL_COVER_LETTER', label: '1.1c) Cover letter' },
  { value: 'DOCUMENTS_EXTERNAL_TECHNICAL_PROPOSAL', label: '1.2 Technical Proposal' },
  { value: 'DOCUMENTS_SIGNED_COMMERCIAL_PROPOSAL', label: '1.3 Signed Commercial Proposal' },
  { value: 'DOCUMENTS_EXTERNAL_NDA', label: '1.4 NDA' },
  { value: 'DOCUMENTS_EXTERNAL_OTHERS', label: '1.5 External Others' },
  { value: 'DOCUMENTS_INTERNAL_COSTSHEET', label: "2.1 Costsheet & Supplier/Install & Suppliers' Quotations" },
  { value: 'DOCUMENTS_INTERNAL_DAMEXE', label: '2.2 Damex-E' },
  { value: 'DOCUMENTS_INTERNAL_ECC_SUPPORTING', label: '2.2.1 ECC Supporting Document' },
  { value: 'DOCUMENTS_INTERNAL_PSS', label: '2.3 PSS' },
  { value: 'DOCUMENTS_INTERNAL_OCC', label: '2.4 OCC' },
  { value: 'DOCUMENTS_INTERNAL_LOA', label: '2.5 LoA & PRR' },
  { value: 'DOCUMENTS_INTERNAL_CONTRIBUTOR_COMMENTS', label: '2.6 Contributor Comments' },
  { value: 'DOCUMENTS_INTERNAL_INSURANCE_COMMENTS', label: '2.7 Insurance Comments' },
  { value: 'DOCUMENTS_INTERNAL_BOND_COMMENTS', label: '2.8 Bond Comments' },
  { value: 'DOCUMENTS_INTERNAL_LEGAL_STATEMENT', label: '2.9 Legal Statement' },
  { value: 'DOCUMENTS_INTERNAL_LEGAL_COMMENTS', label: '2.10 Legal comments' },
  { value: 'DOCUMENTS_INTERNAL_IPR_CHECKLIST', label: '2.11 IPR Checklist' },
  { value: 'DOCUMENTS_INTERNAL_TRR_REPORT', label: '2.12 IPR Checklist' },
  { value: 'DOCUMENTS_INTERNAL_OTHERS', label: '2.13 Internal Others' },
  { value: 'DOCUMENTS_TENDER_FILE', label: '3 Tender File' },
  { value: 'SOURCING_ANNEX', label: '4.1 Sourcing Annex' },
  { value: 'SOURCING_INTERNAL_DOCUMENT', label: '4.2 Sourcing Internal Document' },
  { value: 'VENDOR_QUOTATION', label: '4.3 Vendor Quotation' },
  { value: 'BOOKING_CONFIRMATION_DOCUMENT', label: '5.1 Booking: Customer Confirmation' },
  { value: 'OFFER_BOOKING_COSTSHEET', label: '5.2 Booking: Internal Booking Cost Sheet' },
  { value: 'BOOKING_SUPPORT_DOCUMENT', label: '5.3 Booking: Support Document ' },
  { value: 'BOOKING_NEW_SUPPORT_DOCUMENT', label: '5.4 Booking: Additional Support Document' },
  { value: 'BOOKING_COMMERCIAL_ATTACHMENT', label: '5.5 Booking: Commercial Attachment' },
]
